const ACCESS_POLICY_STORAGE_KEY = "adminOfficeAccessPolicy";

export const readOfficeAccessPolicy = () => {
  try {
    const storedPolicy = localStorage.getItem(ACCESS_POLICY_STORAGE_KEY);
    return storedPolicy ? JSON.parse(storedPolicy) : null;
  } catch {
    return null;
  }
};

export const storeOfficeAccessPolicy = (policy) => {
  if (!policy) return;
  localStorage.setItem(ACCESS_POLICY_STORAGE_KEY, JSON.stringify(policy));
};

const requestPosition = (options) =>
  new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });

export const getCurrentCoordinates = async () => {
  if (!window.isSecureContext && window.location.hostname !== "localhost") {
    throw new Error(
      "Location requires a secure HTTPS connection. Please open the dashboard using HTTPS."
    );
  }

  if (!navigator.geolocation) {
    throw new Error("Location is not supported by this browser.");
  }

  let position;
  try {
    position = await requestPosition({
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0,
    });
  } catch (error) {
    if (error.code === error.PERMISSION_DENIED) {
      throw new Error(
        "Location permission is required. Please allow location access in your browser and try again."
      );
    }

    try {
      position = await requestPosition({
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 30000,
      });
    } catch (fallbackError) {
      if (fallbackError.code === fallbackError.PERMISSION_DENIED) {
        throw new Error(
          "Location permission is required. Please allow location access in your browser and try again."
        );
      }
      if (fallbackError.code === fallbackError.TIMEOUT) {
        throw new Error("Location request timed out. Please try again.");
      }
      throw new Error("Your current location could not be verified.");
    }
  }

  return {
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
    accuracy: position.coords.accuracy,
  };
};

export const getStoredRole = () => {
  const storedRole = String(localStorage.getItem("userRole") || "")
    .trim()
    .toLowerCase();
  if (storedRole) return storedRole;

  try {
    const token = localStorage.getItem("token");
    const payload = token?.split(".")?.[1];
    if (!payload) return "";
    const normalizedPayload = payload
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(Math.ceil(payload.length / 4) * 4, "=");
    return String(JSON.parse(atob(normalizedPayload))?.role || "").toLowerCase();
  } catch {
    return "";
  }
};
